import GetServicePermission from '@/graphql/Permission/GetServicePermission.gql'

import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getServicePermission ({ dispatch }, serviceCodes) {
    try {
      const { data } = await apollo.defaultClient.query({
        query: GetServicePermission,
        variables: {
          serviceCodes
        },
        fetchPolicy: 'no-cache'
      })
      return data.getServicePermission
    } catch (error) {
      dispatch('showError', error)
    }
  }
}
